module.exports = __webpack_public_path__ + "static/media/slide-7.2f18da64.webp";